<template>
  <div class="login-page">
    <app-navbar-login></app-navbar-login>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image" data-color="green">
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <card type="login">
                <h3 slot="header" class="text-center">Verify Your Email</h3>
                <p>A verification email has been sent to your inbox. Please click the link in that email to verify your address.</p>
                <p>Didn't receive it? <router-link :to="{name:  'Resend Verification Email' }">Click here</router-link> to request another verification email.</p>
                </card>
            </div>
          </div>
        </div>
        <app-footer-login></app-footer-login>
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import {Card, Button} from 'src/components/UIComponents';
  import AppNavbarLogin from './Layout/AppNavbarLogin'
  import AppFooterLogin from './Layout/AppFooterLogin'
  export default {
    components: {
      Card,
      AppNavbarLogin,
      AppFooterLogin,
      [Button.name]: Button
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
.login-page .content .container { margin-top: 0px !important; margin-left: 0px;}
.ml-auto, .mx-auto { margin-left: 0px !important; }
.login-page #websphereCoded {margin-left: 40px !important;}
.login-page .h3, .login-page h3 {margin-bottom: 0px; line-height: normal }
.websphere-show {display: none}
</style>
